<template>
  <router-view />
</template>

<script>
export default {
  name: "virtualView",
};
</script>

<style scoped></style>
